import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MetaPreviewData } from '../../../../../../../models/meta-template/preview-interfaces/meta-preview-data.interface';
import { MetaCreativeComponent } from '../../../preview-common/meta-creative/meta-creative.component';
import { MetaPreviewCopy } from '../../../preview-common/meta-preview-copy';

/**
 * Audience Network interstitial: the creative full screen inside a publisher's
 * app, with the headline, two lines of copy and a white button over its foot.
 */
@Component({
  selector: 'app-meta-audience-network-interstitial',
  imports: [CommonModule, MetaCreativeComponent],
  templateUrl: './audience-network-interstitial.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: [
    '../../../preview-common/story/meta-story-styles.scss',
    '../../../preview-common/audience-network/audience-network-styles.scss',
    './audience-network-interstitial.component.scss',
  ]
})
export class MetaAudienceNetworkInterstitialPreviewComponent {
  @Input() data!: MetaPreviewData;

  readonly pageName = MetaPreviewCopy.FACEBOOK_PAGE_NAME;
  readonly avatar = MetaPreviewCopy.AVATAR;

  /** Both paragraphs on one run; CSS clamps it to two lines. */
  get primaryText(): string {
    return MetaPreviewCopy.flat(MetaPreviewCopy.primaryText(this.data));
  }

  get headline(): string {
    return MetaPreviewCopy.headline(this.data);
  }

  get cta(): string {
    return MetaPreviewCopy.cta(this.data);
  }
}
